interface Props {
  className?: string;
}

// иконка крестика
// todo возможно нужно удалить, есть CloseIcon
export function CrossIcon({className}: Props): JSX.Element {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.00023 0.878662L4.06089 1.93932L8.00023 5.87866L11.9396 1.93932L13.0002 0.878662L15.1215 2.99998L14.0609 4.06064L10.1215 7.99998L14.0609 11.9393L15.1215 13L13.0002 15.1213L11.9396 14.0606L8.00023 10.1213L4.06089 14.0606L3.00023 15.1213L0.878906 13L1.93957 11.9393L5.87891 7.99998L1.93957 4.06064L0.878906 2.99998L3.00023 0.878662Z"
        fill="white"
      />
    </svg>
  );
}
